export default {
    addEncounter: (state, encounter) => {
        state.saved.push(encounter)
    },
    removeEncounterById: (state, encounterId) => {
        state.saved = state.saved.filter(enc => enc.session.uuid !== encounterId)
    },
}
